import { Download, ShoppingCart } from 'lucide-react';
import { BOOKS } from '@/data/mockData';
import { SectionTitle, FadeIn } from '@/components/common/SectionTitle';
import { HOME } from '@/constants/testIds';
import { useAuth } from '@/contexts/AuthContext';

const BooksResources = () => {
  const { user } = useAuth();
  const handleDownload = () => {
    if (!user) window.location.href = '/learning-hub#sign-in';
    else window.location.href = '/student';
  };
  return (
    <section className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          label="Books & Resources"
          title={<span className="font-semibold">Hand-crafted learning artefacts to accelerate your transformation.</span>}
          subtitle="Premium e-books, interview banks and AI prompt libraries — authored by industry practitioners."
        />

        <div data-testid={HOME.booksGrid} className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {BOOKS.map((b, i) => (
            <FadeIn key={b.title} delay={i * 0.1}>
              <div className="group h-full glass rounded-2xl overflow-hidden hover:border-brand-cyan/40 transition flex flex-col">
                <div className="aspect-[3/4] overflow-hidden bg-black relative">
                  <img
                    src={b.coverUrl}
                    alt={b.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3">
                    <div className="text-[10px] font-mono uppercase tracking-widest text-brand-cyan">{b.type}</div>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-display font-bold text-base leading-tight">{b.title}</h3>
                  <p className="mt-1 text-xs text-white/60">{b.subtitle}</p>
                  <button
                    type="button"
                    onClick={b.cta === 'Download' ? handleDownload : undefined}
                    className="mt-4 inline-flex items-center justify-center gap-2 text-xs font-semibold py-2 px-3 rounded-lg border border-brand-cyan/30 text-brand-cyan hover:bg-brand-cyan/10 transition"
                  >
                    {b.cta === 'Download' ? <Download className="w-3.5 h-3.5" /> : <ShoppingCart className="w-3.5 h-3.5" />}
                    {b.cta}
                  </button>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BooksResources;
